import { menuFirsts, menuSeconds } from 'constants/menus'
import routeTreatmentTemplateTypes from 'routes/settings/treatment-template-types'

import { Config } from 'config'
import Dashboard from 'features/dashboard/dashboard'
import FollowUp from 'features/follow-up/follow-up'
import Home from 'features/home/home'
import Welcome from 'features/page/welcome'
import InvoiceView from 'features/treatments/InvoiceView'
import UpdateSidebar from 'features/update/update'
import routeClinicManagements from 'routes/admin/clinic-managements.routes'
import routeCustom from 'routes/admin/custom.routes'
import routeApplication from 'routes/application/application.routes'
import routeApproval from 'routes/application/approval.routes'
import routeCheckIn from 'routes/check-in/check-in'
import routeAppointment from 'routes/counter/appointment.routes'
import routeDoctorAppointmentSchedule from 'routes/counter/doctor-appointment-schedule.routes'
import routeDoctorSchedule from 'routes/counter/doctor-schedule.routes'
import routeManageDoctorFee from 'routes/counter/manage-doctor-fee.routes'
import routeManageDoctorLabFee from 'routes/counter/manage-doctor-lab-fee.routes'
import routeNhsoTraetment from 'routes/counter/nhso-treatment.route'
import routePatientManagement from 'routes/counter/patient-management.routes'
import routeRecallLists from 'routes/counter/recall-list.routes'
import routeRegister from 'routes/counter/register.routes'
import routeRetrospectiveEdit from 'routes/counter/retrospectiveEdit.routes'
import routeFinancesMain from 'routes/finance/finances.routes'
import routeLabOrder from 'routes/lab-order.routes'
import routePromotion from 'routes/manage-crm/promotion.routes'
import routeVoucher from 'routes/manage-crm/voucher.routes'
import routeReport from 'routes/report.routes'
import routeRetrospectiveOrder from 'routes/retrospectiveOrder/retrospectiveOrder.routes'
import { routeName } from 'routes/routes-name'
import routeBranchServicePoint from 'routes/settings/branch-service-point.routes'
import routeCreditFeeManagements from 'routes/settings/credit-fee-managements.routes'
import routeDefaultLabs from 'routes/settings/default-labs.routes'
import routeDefaultProducts from 'routes/settings/default-products.routes'
import routeDefaultUsers from 'routes/settings/default-users.routes'
import routeDefaults from 'routes/settings/defaults.routes'
import routeDoctorFeeManagements from 'routes/settings/doctor-fee-managements.routes'
import routeDoctorNote from 'routes/settings/dotor-note.routes'
import routeFinances from 'routes/settings/finances.routes'
import routePersonnelManagements from 'routes/settings/personnel-managements.routes'
import routeTreatmentCourses from 'routes/settings/treatment-courses.routes'
import routeTreatmentPlans from 'routes/settings/treatment-plans.routes'
import routeTreatmentRight from 'routes/settings/treatment-right.routes'
import routeTreatments from 'routes/settings/treatments.routes'
import routeTreatmentsIndex from 'routes/treatment/treatment.routes'
import routeImportProduct from 'routes/warehouses/import-product.routes'
import routeWarehouses from 'routes/warehouses/warehouses.routes'
import routeXray from 'routes/xray/xray.routes'
import routeMemberManagements from './routes/settings/member-management.routes'

const routes = [
  {
    key: menuSeconds.HOME.key,
    name: menuSeconds.HOME.name,
    textName: menuSeconds.HOME.textName,
    component: Home,
    path: '/',
    appBar: true
  },
  {
    key: menuFirsts.WELCOME.key,
    name: menuFirsts.WELCOME.name,
    textName: menuFirsts.WELCOME.textName,
    component: Welcome,
    path: routeName.welcome,
    appBar: true
  },
  {
    key: menuFirsts.WELCOME.key,
    name: menuFirsts.WELCOME.name,
    textName: menuFirsts.WELCOME.textName,
    component: UpdateSidebar,
    path: routeName.update,
    appBar: true
  },
  {
    key: menuSeconds.DASHBOARD.key,
    packageKey: menuSeconds.DASHBOARD.packageKey,
    name: menuSeconds.DASHBOARD.name,
    textName: menuSeconds.DASHBOARD.textName,
    component: Dashboard,
    path: routeName.dashboard,
    appBar: true
  },
  {
    key: menuSeconds.FOLLOW_UP.key,
    packageKey: menuSeconds.FOLLOW_UP.packageKey,
    name: menuSeconds.FOLLOW_UP.name,
    textName: menuSeconds.FOLLOW_UP.textName,
    component: FollowUp,
    path: routeName.followUp,
    appBar: true
  },
  ...routeDefaults,
  ...routeDefaultProducts,
  ...routeFinances,
  ...routePersonnelManagements,
  ...routeDefaultUsers,
  ...routeDefaultLabs,
  ...routeTreatmentCourses,
  ...routeTreatmentPlans,
  ...routeTreatments,
  ...routeTreatmentTemplateTypes,
  ...routeBranchServicePoint,
  ...routeDoctorFeeManagements,
  ...routeWarehouses,
  ...routeImportProduct,
  ...routeTreatmentRight,
  ...routeRegister,
  ...routeDoctorSchedule,
  ...routeDoctorAppointmentSchedule,
  ...routeAppointment,
  ...routePatientManagement,
  ...routeRetrospectiveEdit,
  ...routeTreatmentsIndex,
  ...routeClinicManagements,
  ...routeCustom,
  ...routeFinancesMain,
  ...routeTreatmentsIndex,
  ...routeXray,
  ...routeLabOrder,
  ...routeRetrospectiveOrder,
  ...routeApplication,
  ...routeReport,
  ...routeRecallLists,
  ...routeManageDoctorFee,
  ...routeManageDoctorLabFee,
  ...routeNhsoTraetment,
  ...routeDoctorNote,
  ...routeCreditFeeManagements,
  ...(Config?.IS_TDH === '1' ? routeCheckIn : []),
  ...routeMemberManagements,
  ...routeApproval,
  ...routePromotion,
  ...routeVoucher,
  {
    key: 'BACKEND',
    name: 'Invoice View',
    textName: 'Invoice View',
    component: InvoiceView,
    path: routeName.invoiceView,
    appBar: false
  }
]

export default routes
